<template>
  <div class="record-box">
    <div class="title">{{ info.formatDate }}</div>
    <div class="content">
      <app-job-item v-for="item in info.array" :key="item.id" :info="item" type="record" is-log></app-job-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppJobRecordItem',
  components: {},
  props: {
    info: Object,
  },
  data() {
    return {
    };
  },
  computed: {},
  methods: {},
}

</script>
<style lang='less' scoped>
.record-box {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
  .title {
    line-height: 80px;
    height: 80px;
    padding: 0 30px;
    color: #666666;
    font-size: 24px;
  }
}
</style>